import { useCallback } from "react";
import type { NumberFormatValues } from "react-number-format";

type UseInputNumberValidationProps = {
  min?: string | number;
  max?: string | number;
  isAllowed?: (value: NumberFormatValues) => boolean;
};

const useInputNumberValidation = (props: UseInputNumberValidationProps) =>
  useCallback(
    (value: NumberFormatValues) => {
      const { min, max, isAllowed } = props;
      const predicates: boolean[] = [];

      // Min and max
      min && value.floatValue && predicates.push(value.floatValue >= +min);
      max && value.floatValue && predicates.push(value.floatValue <= +max);

      // Safe integer
      value.floatValue &&
        predicates.push(value.floatValue >= Number.MIN_SAFE_INTEGER && Number.MAX_SAFE_INTEGER >= value.floatValue);

      // Custom isAllowed
      isAllowed && predicates.push(isAllowed(value));

      return predicates.every(Boolean);
    },
    [props.min, props.max, props.isAllowed]
  );

export default useInputNumberValidation;
